/* eslint-disable react/jsx-no-leaked-render */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { FloatingFocusManager, FloatingOverlay, FloatingPortal, autoUpdate, flip, offset, shift, useDismiss, useFloating, useInteractions, useRole } from '@floating-ui/react';
import T from 'prop-types';
import React, { createContext, forwardRef, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { AREA_TYPE } from '../../../constants/product';
import { RIGHT_MENU_WIDTH_PX } from '../../RightMenu/RightMenu';
import ShapeMenu from '../../shapeMenu/ShapeMenu';
export var CTX_TRIGGERS = {
    shapeRightClicked: 'onShapeRightClicked',
    lhsDropdown: 'lhsDropdown'
};
var ContextMenuCtx = /*#__PURE__*/ createContext(null);
export var useContextMenuCtx = function() {
    var ctx = useContext(ContextMenuCtx);
    if (ctx === null) {
        throw new Error('ContextMenu must be wrapped in <ContextMenuCtxProvider />');
    }
    return ctx;
};
export var ContextMenuCtxProvider = function(param) {
    var children = param.children;
    var isRightMenuVisible = useSelector(function(reduxState) {
        return reduxState.layout.rightMenu.isVisible;
    });
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), floatingOverlayStyle = _useState1[0], setFloatingOverlayStyle = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), customOffset = _useState2[0], setCustomOffset = _useState2[1];
    var floatingReturn = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            flip({
                crossAxis: false,
                // all of detectOverflow's options can be passed
                //  so we'll add right-padding for the cart
                padding: {
                    right: isRightMenuVisible ? RIGHT_MENU_WIDTH_PX : 0
                }
            }, // stateful values inside functions aren't fresh or reactive: https://floating-ui.com/docs/useFloating#option-reactivity
            //  we need to specify dependencies to make it so
            [
                isRightMenuVisible
            ]),
            shift(),
            customOffset && offset(customOffset)
        ],
        placement: 'right-start',
        strategy: 'fixed',
        whileElementsMounted: autoUpdate
    });
    return /*#__PURE__*/ React.createElement(ContextMenuCtx.Provider, {
        value: _object_spread_props(_object_spread({}, floatingReturn), {
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            floatingOverlayStyle: floatingOverlayStyle,
            setFloatingOverlayStyle: setFloatingOverlayStyle,
            setCustomOffset: setCustomOffset
        })
    }, children);
};
ContextMenuCtxProvider.propTypes = {
    children: T.node
};
export var ShapeMenuWrapper = /*#__PURE__*/ forwardRef(function(param, ref) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: className
    }, children);
});
ShapeMenuWrapper.displayName = 'ShapeMenuWrapper';
ShapeMenuWrapper.propTypes = {
    children: T.node.isRequired,
    className: T.string
};
export var ContextMenu = /*#__PURE__*/ forwardRef(function(param, rootRef) {
    var data = param.data;
    var _useContextMenuCtx = useContextMenuCtx(), isOpen = _useContextMenuCtx.isOpen, setIsOpen = _useContextMenuCtx.setIsOpen, floatingStyles = _useContextMenuCtx.floatingStyles, refs = _useContextMenuCtx.refs, context = _useContextMenuCtx.context, floatingOverlayStyle = _useContextMenuCtx.floatingOverlayStyle;
    var role = useRole(context, {
        role: 'menu'
    });
    var dismiss = useDismiss(context);
    var getFloatingProps = useInteractions([
        role,
        dismiss
    ]).getFloatingProps;
    var handleCloseMenu = function() {
        setIsOpen(false);
    };
    return /*#__PURE__*/ React.createElement(FloatingPortal, {
        root: rootRef
    }, isOpen && /*#__PURE__*/ React.createElement(FloatingOverlay, _object_spread({
        lockScroll: true
    }, floatingOverlayStyle && {
        style: floatingOverlayStyle
    }), /*#__PURE__*/ React.createElement(FloatingFocusManager, {
        context: context,
        initialFocus: refs.floating
    }, /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        ref: refs.setFloating,
        style: floatingStyles
    }, getFloatingProps()), {
        className: "context-menu-floating"
    }), data && /*#__PURE__*/ React.createElement(ShapeMenu, {
        data: data,
        DropdownMenuComponent: ShapeMenuWrapper,
        className: "context-menu",
        areaType: AREA_TYPE.SHAPE_AREA,
        closeMenu: handleCloseMenu,
        showShapeName: true,
        closeDropdownOnSelect: false
    })))));
});
ContextMenu.displayName = 'ContextMenu';
ContextMenu.propTypes = {
    data: T.object
};
